import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {BaseFillDataFormComponent} from '../base-fill-data-form-component';

@Component({
  selector: 'app-label-radio-input',
  templateUrl: './label-radio-input.component.html'
})
export class LabelRadioInputComponent extends BaseFillDataFormComponent implements OnInit {
  @Input() inputName: string;
  @Input() label: string;
  @Input() valuesLabelPrefix: string;
  @Input() formGroup: FormGroup;
  @Input() items: any;

  itemsArray: number[];
  itemsNamesArray: string[];

  ngOnInit(): void {
    this.itemsArray = [];
    this.itemsNamesArray = [];
    for (const n in this.items) {
      if (!isNaN(Number.parseInt(n))) {
        this.itemsArray.push(Number.parseInt(n));
      } else {
        this.itemsNamesArray.push(n);
      }
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/form-section/label-radio-input/label-radio-input.component.ts